export const DVSUM_TOOLTIP_CLASS_NAME = "dvsum-tooltip";
export const WORKFLOW_TOOLTIP_LABEL = "Metadata Workflow Enabled";
export const DQ_WORKFLOW_TOOLTIP_LABEL = "Data Quality Workflow Enabled";
export const DQ_METADATA_WORKFLOW_TOOLTIP_LABEL =
  "Data Quality and Metadata Workflow Enabled";
